// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgAutorefreshPlay24 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<g clipPath="url(#autorefresh_play_24_svg__a)">
			<path
				fill="#A0B6C3"
				d="M12 24c6.563 0 12-5.425 12-12 0-6.563-5.437-12-12.012-12C5.425 0 0 5.437 0 12c0 6.575 5.437 12 12 12Zm0-2.358A9.608 9.608 0 0 1 2.37 12a9.588 9.588 0 0 1 9.618-9.63c5.344 0 9.654 4.286 9.654 9.63A9.618 9.618 0 0 1 12 21.642Zm-2.184-5.065 6.68-3.927a.745.745 0 0 0 0-1.277l-6.68-3.938c-.511-.302-1.185-.047-1.185.522v8.097c0 .57.64.848 1.185.523Z"
			/>
		</g>
		<defs>
			<clipPath id="autorefresh_play_24_svg__a">
				<path fill="#fff" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);
export default SvgAutorefreshPlay24;
